<style lang="scss" scoped>
    footer {
        display: flex;
        justify-content: space-between;
        color: $white;
        padding: 15px;
        font-size: toRem(12px);
        line-height: lh(17px, 12px);

        a {
            @include link-colors($white, $color-primary);
        }

        .copyright {}

        .attribution {
            a {
                font-weight: bold;
            }
        }
    }
</style>
<template>
    <footer>
        <div class="copyright">
            <a href="#!" @click.prevent>
                Terms of Use
            </a>
            /
            &copy; 2018 FlowJo
        </div>
        <div class="attribution">
            <a href="https://clever.ly" target="_blank" rel="noopener">
                clever.ly
            </a>
            crafted
        </div>
    </footer>
</template>
<script>
export default {
    name: 'AppFooter',
}
</script>
